import React,{ useState, useEffect } from 'freact'
import About from './about';

export default function App() {
return <About/>
}
